<template>
    <div
        class="custom-control custom-checkbox"
        :class="[
            { 'custom-checkbox-lg': large },
            { 'pe-none': radioType && localValue },
            { 'custom-radio': type === 'radio' }
        ]"
    >
        <input
            v-model="localValue"
            v-tooltip="inputTooltip"
            type="checkbox"
            class="custom-control-input"
            :id="id || name"
            :name="name"
            :disabled="disabled"
            :required="required"
            :readonly="readonly"
            @click="handleClick"
        />
        <label class="custom-control-label d-flex" :for="name">
            <slot v-if="$slots.default" />
            <span
                v-else
                v-html="$options.filters.sanitizeHtml(label)"
                :style="'padding-top: 1px'"
                v-tooltip="tooltipLabel"
            />
            <a-icon
                v-if="tooltip && tooltipIcon"
                v-tooltip="tooltip"
                style="min-width: 16px; width: 16px"
                class="ml-1"
                icon="Info"
            />
            <span v-if="required" class="text-danger" v-text="'*'" />
        </label>
    </div>
</template>

<script>
export default {
    name: 'UiCheckboxInput',
    props: {
        label: {
            type: String,
            default: ''
        },
        name: {
            type: String,
            required: true
        },
        value: {
            type: Boolean,
            default: false
        },
        disabled: {
            typ: Boolean,
            default: false
        },
        required: {
            typ: Boolean,
            default: false
        },
        large: {
            type: Boolean,
            default: false
        },
        tooltip: {
            type: String,
            required: false
        },
        tooltipLabel: {
            type: String,
            required: false
        },
        tooltipIcon: {
            type: Boolean,
            default: true
        },
        radioType: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: 'checkbox'
        },
        id: {
            type: String,
            required: false
        },
        readonly: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        localValue: {
            get() {
                return this.value
            },
            set(value) {
                if (this.readonly) return
                this.$emit('input', value)
                this.$emit('change', value)
            }
        },
        inputTooltip() {
            if (this.tooltipIcon || !this.tooltip) return ''
            return this.tooltip
        }
    },

    methods: {
        handleClick(event) {
            if (this.readonly) {
                event.preventDefault()
            }
        }
    }
}
</script>

<style lang="scss">
.custom-control.custom-checkbox {
    .custom-control-label {
        line-height: 1.5;
        font-size: inherit;

        &::before {
            border: 1px solid var(--color-gray-500);
        }
    }
}
</style>
